/* global jQuery, aggregate_vitamins */
import { isFormat, onFormat } from "./format.js";
import { getLanguages } from "./util.js";

export const allSliders = () => {
  const selectors = [
    "#aggregateslider",
    "#childslider",
    "#infantslider",
    "#linearslider",
    "#newaspreparedsliderleft",
    "#newaspreparedsliderright",
    "#newaggregatesliderleft",
    "#newaggregatesliderright",
    "#newcanadaslider",
    "#newchildslider",
    "#newdualsliderleft",
    "#newdualsliderright",
    "#newdualtabularsliderleft",
    "#newdualtabularsliderright",
    "#newinfantslider",
    "#newlinearcanadaslider",
    "#newtabularcanadaslider",
    "#canada-as-prepared-slider",
    "#ca-aggregate-slider-left",
    "#ca-aggregate-slider-right",
    "#newlinearslider",
    "#newtabularslider",
    "#newverticalslider",
    "#standardslider",
    "#tabularslider",
  ];

  return jQuery(selectors.join(", "));
};

const isNumber = (n) => {
  return typeof n === "number";
};

const /* For formats that only have one width */
  SLIDER_SOLE = 0,
  /* The new FDA vertical dual labels store: [singleWidth, dualLeft, dualRight] */
  SLIDER_NEW_VERTICAL_SINGLE = 0,
  SLIDER_NEW_VERTICAL_DUAL_LEFT = 1,
  SLIDER_NEW_VERTICAL_DUAL_RIGHT = 2,
  /* The new FDA tabular dual labels store: [singleWidth, dualLeft, dualRight] */
  SLIDER_NEW_TABULAR_SINGLE = 0,
  SLIDER_NEW_TABULAR_DUAL_LEFT = 1,
  SLIDER_NEW_TABULAR_DUAL_RIGHT = 2,
  SLIDER_NEW_AS_PREPARED_LEFT = 0,
  SLIDER_NEW_AS_PREPARED_RIGHT = 1,
  SLIDER_NEW_AGGREGATE_LEFT = 0,
  SLIDER_NEW_AGGREGATE_RIGHT = 1,
  SLIDER_CA_AGGREGATE_LEFT = 0,
  SLIDER_CA_AGGREGATE_RIGHT = 1;

export const sliderValue = (sliderElement) => {
  const e = jQuery(sliderElement);
  return e.slider("option", "value");
};

export const setSliderValue = (sliderElement, value) => {
  const e = jQuery(sliderElement);
  return e.slider("option", "value", value);
};

export const refreshSlider = (sliderElement) => {
  const e = jQuery(sliderElement);
  return e.slider("option", "value", e.slider("option", "value"));
};

export const initializeSliders = ({
  saveSliderEvent,
  rebuildFunction,
  adjustDailyValueHeight,
  adjustServingFontSize,
  adjustDualServingSizeLineHeight,
  adjustNewLinearLineHeightForCalorieFont,
}) => {
  // When the sliders get replaced they stick around and replacing triggers the change event
  // Delete any existing ones so they can re-initialize properly
  jQuery(".ui-slider").each(function () {
    jQuery(this).slider("destroy");
  });

  const standardSliderChange = (event, ui) => {
    jQuery(
      ".nutritionfactstable, .labelright, .vitaminbullet, .vitaminright, .carbconversion, " +
        ".protein-conversion, .asterisksection, #asterisktable, #asterisksection-replace, " +
        "#insignificant-nutrients-list, .watermark"
    ).css("width", ui.value);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 10);
    jQuery(".subright, .subright-sat-trans").css("width", ui.value - 10);
    jQuery(".asterisk_text:visible").css("width", ui.value - 5);

    /* decrement font-size of 'nutrition facts' as well below threshold - is there a way to
       measure width of text? */
    jQuery(".nutritionheading").css("font-size", ui.value / 8.43);

    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#standardslider").slider({
    min: 180,
    max: 250,
    value: 207,
    slide: standardSliderChange,
    change: standardSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const newCanadaSliderChange = (event, ui) => {
    jQuery(
      "#newcanadanutritionfactstable, #new-canada-ingredients-allergens-table, .labelright-wide, " +
        ".recipe-show-new-canada-ingredient-list, .recipe-show-new-canada-french-ingredient-list, " +
        ".allergen-list-canada-english, .allergen-list-canada-french, " +
        ".facility-allergen-list-canada-english, .facility-allergen-list-canada-french, .watermark"
    ).css("width", ui.value);
    jQuery("#recipe_manufactured_at, #facility-allergen-list, #bioengineered-claim").css(
      "width",
      ui.value + 10
    );
    jQuery(".subright-wide, .subright-sat-trans").css("width", ui.value - 10);
    jQuery("#slider-size").html(ui.value);
    adjustDailyValueHeight();
  };

  jQuery("#newcanadaslider").slider({
    min: 150,
    max: 260,
    value: 227,
    slide: newCanadaSliderChange,
    change: newCanadaSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const newLinearCanadaSliderChange = (event, ui) => {
    jQuery("#newlinearcanadanutritionfactstable").css("width", ui.value);
    jQuery(
      "#new-canada-ingredients-allergens-table, .recipe-show-new-canada-ingredient-list, " +
        ".recipe-show-new-canada-french-ingredient-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, .watermark"
    ).css("width", ui.value - 2);
    jQuery("#recipe_manufactured_at, #facility-allergen-list, #bioengineered-claim").css(
      "width",
      ui.value + 8
    );
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newlinearcanadaslider").slider({
    min: 140,
    max: 1200,
    value: 430,
    slide: newLinearCanadaSliderChange,
    change: newLinearCanadaSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const newTabularCanadaSliderChange = (event, ui) => {
    const isSimplified = jQuery("#newcanadasimplifiedformattoggle").is(":checked");
    const columns = isSimplified
      ? jQuery(".CaTabularNFP-NutrientCols--simplified").first().children().length
      : jQuery(".CaTabularNFP-NutrientCols").first().children().length;
    const guttersAndPadding = 8 + 7 * columns;
    const footer = ui.value * columns + (columns - 1) * 7;
    const total = ui.value * columns + 108 + guttersAndPadding;
    jQuery(".CaTabularNFP-NutrientCol").css("width", ui.value);
    jQuery(".CaTabularNFP-Footnote").css("width", footer);
    jQuery(
      "#new-canada-ingredients-allergens-table, .recipe-show-new-canada-ingredient-list, " +
        ".recipe-show-new-canada-french-ingredient-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, .watermark"
    ).css("width", total - 8);
    jQuery("#recipe_manufactured_at, #facility-allergen-list, #bioengineered-claim").css(
      "width",
      total
    );
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newtabularcanadaslider").slider({
    min: 140,
    max: 200,
    value: 150,
    slide: newTabularCanadaSliderChange,
    change: newTabularCanadaSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const canadaAsPreparedSliderChange = (event, ui) => {
    jQuery(".CaDualFormatNFP").css("width", ui.value);

    let leftColWidth;
    const numLanguages = getLanguages().length;
    if (numLanguages == 2) {
      leftColWidth = 150;
    } else {
      leftColWidth = 75;
    }

    jQuery(".CaDualFormatNFP-LeftCol").each(function () {
      // Only set the first (first in html last when rendered because of float) dual column width
      jQuery(this)
        .next(".CaDualFormatNFP-DualFormatCol")
        .css("width", (ui.value - leftColWidth) / 2);
    });

    jQuery(
      "#new-canada-ingredients-allergens-table," +
        ".recipe-show-new-canada-ingredient-list, .recipe-show-new-canada-french-ingredient-list, " +
        ".allergen-list-canada-english, .allergen-list-canada-french, " +
        ".facility-allergen-list-canada-english, .facility-allergen-list-canada-french, " +
        ".watermark"
    ).css("width", ui.value);
    jQuery("#recipe_manufactured_at, #facility-allergen-list").css("width", ui.value + 10);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#canada-as-prepared-slider").slider({
    min: 200,
    max: 500,
    value: 360,
    slide: canadaAsPreparedSliderChange,
    change: canadaAsPreparedSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const canadaAggregateTotalWidth = (leftWidth, rightWidth) => {
    const recipeCount = aggregate_vitamins.length;
    return recipeCount * (rightWidth + 7) + leftWidth;
  };

  const adjustFontSize = (element, maxFontSize, minFontSize = 6) => {
    let fontSize = maxFontSize;
    element.style.fontSize = fontSize + "px";

    // Gradually reduce font size until it fits within container width
    while (element.scrollWidth > element.offsetWidth && fontSize > minFontSize) {
      fontSize -= 1;
      element.style.fontSize = fontSize + "px";
    }
  };

  const canadaAggregateSliderLeftChange = (event, ui) => {
    jQuery(".CaAggregate-LeftCol").css("width", ui.value);
    jQuery("#slider-size").html(ui.value);

    const rightWidth = sliderValue("#ca-aggregate-slider-right");
    const totalWidth = canadaAggregateTotalWidth(ui.value, rightWidth);

    // jQuery("#CaAggregate-TopHeading").css("font-size", ui.value / 8.43);
    jQuery(
      ".CaAggregate, #new-canada-ingredients-allergens-table," +
        ".ca-agg-ingredient-list-recipe-name," +
        ".recipe-show-new-canada-ingredient-list, .recipe-show-new-canada-french-ingredient-list, " +
        ".allergen-list-canada-english, .allergen-list-canada-french, " +
        ".facility-allergen-list-canada-english, .facility-allergen-list-canada-french"
    ).css("width", totalWidth);
    jQuery("#recipe_manufactured_at, #facility-allergen-list").css("width", totalWidth + 10);

    document.querySelectorAll(".responsive-heading").forEach((el) => {
      adjustFontSize(el, 17.3, 13);
    });
  };

  jQuery("#ca-aggregate-slider-left").slider({
    min: 96,
    max: 205,
    value: 160,
    slide: canadaAggregateSliderLeftChange,
    change: canadaAggregateSliderLeftChange,
    stop: saveSliderEvent(SLIDER_CA_AGGREGATE_LEFT),
  });

  const canadaAggregateSliderRightChange = (event, ui) => {
    jQuery(".CaAggregate-RecipeCol").css("width", ui.value);
    jQuery("#slider-size2").html(ui.value);

    const leftWidth = sliderValue("#ca-aggregate-slider-left");
    const totalWidth = canadaAggregateTotalWidth(leftWidth, ui.value);

    jQuery(
      ".CaAggregate, #new-canada-ingredients-allergens-table," +
        ".ca-agg-ingredient-list-recipe-name," +
        ".recipe-show-new-canada-ingredient-list, .recipe-show-new-canada-french-ingredient-list, " +
        ".allergen-list-canada-english, .allergen-list-canada-french, " +
        ".facility-allergen-list-canada-english, .facility-allergen-list-canada-french"
    ).css("width", totalWidth);
    jQuery("#recipe_manufactured_at, #facility-allergen-list").css("width", totalWidth + 10);

    document.querySelectorAll(".responsive-heading").forEach((el) => {
      adjustFontSize(el, 17.3, 13);
    });
  };

  jQuery("#ca-aggregate-slider-right").slider({
    min: 79,
    max: 200,
    value: 100,
    slide: canadaAggregateSliderRightChange,
    change: canadaAggregateSliderRightChange,
    stop: saveSliderEvent(SLIDER_CA_AGGREGATE_RIGHT),
  });

  const newVerticalSliderChange = (event, ui) => {
    jQuery("#newnutritionfactstable, .watermark").css("width", ui.value);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, #facility-allergen-list, " +
        "#bioengineered-claim"
    ).css("width", ui.value + 10);

    jQuery("#newnutritionheading").css("font-size", ui.value / 8.43);
    adjustServingFontSize();
    jQuery(".asterisk_text").css("width", ui.value - 5);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newverticalslider").slider({
    min: 180,
    max: 280,
    value: 227,
    slide: newVerticalSliderChange,
    change: newVerticalSliderChange,
    stop: saveSliderEvent(SLIDER_NEW_VERTICAL_SINGLE),
  });

  const newDualSliderLeftChange = (event, ui) => {
    const rightWidth = sliderValue("#newdualsliderright");
    jQuery(".dual-left-col").css("width", ui.value);
    jQuery("#newdualnutritionfactstable").css("width", ui.value + rightWidth * 2 + 14);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, #facility-allergen-list, " +
        "#bioengineered-claim, .watermark"
    ).css("width", ui.value + 10 + rightWidth * 2 + 14);

    jQuery("#newdualnutritionheading").css("font-size", (ui.value + rightWidth * 2 + 14) / 8.43);
    jQuery(".asterisk_text:visible").css("width", ui.value + rightWidth * 2 + 14 - 5);
    jQuery(".subhairlineseparator:visible").css("width", ui.value - 20);
    jQuery(".subsubhairlineseparator:visible").css("width", ui.value - 40);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newdualsliderleft").slider({
    min: 100,
    max: 140,
    value: 117,
    slide: newDualSliderLeftChange,
    change: newDualSliderLeftChange,
    stop: saveSliderEvent(SLIDER_NEW_VERTICAL_DUAL_LEFT),
  });

  const newDualSliderRightChange = (event, ui) => {
    const leftWidth = sliderValue("#newdualsliderleft");
    jQuery(".dual-serving-col, .dual-package-col").css("width", ui.value);
    jQuery("#newdualnutritionfactstable").css("width", ui.value * 2 + leftWidth + 14);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, #facility-allergen-list, " +
        "#bioengineered-claim, .watermark"
    ).css("width", ui.value * 2 + 10 + leftWidth + 14);

    jQuery("#newdualnutritionheading").css("font-size", (ui.value * 2 + leftWidth + 14) / 8.43);
    jQuery(".asterisk_text:visible").css("width", leftWidth + ui.value * 2 + 14 - 5);
    jQuery("#slider-size2").html(ui.value);
    adjustDualServingSizeLineHeight();
  };

  jQuery("#newdualsliderright").slider({
    min: 70,
    max: 100,
    value: 85,
    slide: newDualSliderRightChange,
    change: newDualSliderRightChange,
    stop: saveSliderEvent(SLIDER_NEW_VERTICAL_DUAL_RIGHT),
  });

  const newAsPreparedSliderLeftChange = (event, ui) => {
    const rightWidth = sliderValue("#newaspreparedsliderright");
    jQuery(".dual-left-col").css("width", ui.value);
    jQuery("#newaspreparednutritionfactstable").css("width", ui.value + rightWidth * 2 + 14);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, #facility-allergen-list, " +
        "#bioengineered-claim, .watermark"
    ).css("width", ui.value + 10 + rightWidth * 2 + 14);

    jQuery("#newaspreparednutritionheading").css(
      "font-size",
      (ui.value + rightWidth * 2 + 14) / 8.43
    );
    jQuery(".asterisk_text:visible").css("width", ui.value + rightWidth * 2 + 14 - 5);
    jQuery(".subhairlineseparator:visible").css("width", ui.value - 20);
    jQuery(".subsubhairlineseparator:visible").css("width", ui.value - 40);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newaspreparedsliderleft").slider({
    min: 100,
    max: 140,
    value: 117,
    slide: newAsPreparedSliderLeftChange,
    change: newAsPreparedSliderLeftChange,
    stop: saveSliderEvent(SLIDER_NEW_AS_PREPARED_LEFT),
  });

  const newAsPreparedSliderRightChange = (event, ui) => {
    const leftWidth = sliderValue("#newaspreparedsliderleft");
    jQuery(".dual-serving-col, .dual-package-col").css("width", ui.value);
    jQuery("#newaspreparednutritionfactstable").css("width", ui.value * 2 + leftWidth + 14);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, #facility-allergen-list, " +
        "#bioengineered-claim, .watermark"
    ).css("width", ui.value * 2 + 10 + leftWidth + 14);

    jQuery("#newaspreparednutritionheading").css(
      "font-size",
      (ui.value * 2 + leftWidth + 14) / 8.43
    );
    jQuery("#slider-size2").html(ui.value);
    jQuery(".asterisk_text:visible").css("width", leftWidth + ui.value * 2 + 14 - 5);
    adjustDualServingSizeLineHeight();
  };

  jQuery("#newaspreparedsliderright").slider({
    min: 60,
    max: 100,
    value: 85,
    slide: newAsPreparedSliderRightChange,
    change: newAsPreparedSliderRightChange,
    stop: saveSliderEvent(SLIDER_NEW_AS_PREPARED_RIGHT),
  });

  const setNewAggregateHeadingSize = () => {
    const setHeight = (value) => {
      jQuery("#newaggregatenutritionheading").height(value);
      jQuery(".package-name").height(value);
    };

    setHeight("");

    let height = jQuery("#newaggregatenutritionheading").height();
    jQuery(".package-name").each(function () {
      const nameHeight = jQuery(this).height();
      if (nameHeight > height) {
        height = nameHeight;
      }
    });
    setHeight(height);
  };

  const newAggregateSliderLeftChange = (event, ui) => {
    const leftWidth = ui.value;
    const rightWidth = sliderValue("#newaggregatesliderright");
    const recipeCount = aggregate_vitamins.length;

    jQuery(".agg-left-col").css("width", ui.value - 3);
    jQuery(".agg-vitamin-left-col").css("width", ui.value - 3 - 120);
    jQuery(
      "#newaggregatenutritionfactstable, .agg-ingredient-list, .agg-ingredient-list-recipe-name, .agg-allergen-list, " +
        "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, #facility-allergen-list, " +
        "#bioengineered-claim, .watermark"
    ).css("width", leftWidth + (rightWidth + 7) * recipeCount);

    jQuery("#newaggregatenutritionheading").css("font-size", leftWidth / 8.43);
    jQuery(".subhairlineseparator:visible").css("width", leftWidth - 20);
    jQuery(".subsubhairlineseparator:visible").css("width", leftWidth - 40);
    jQuery("#slider-size").html(ui.value);

    setNewAggregateHeadingSize();
  };

  jQuery("#newaggregatesliderleft").slider({
    min: 175,
    max: 280,
    value: 240,
    slide: newAggregateSliderLeftChange,
    change: newAggregateSliderLeftChange,
    stop: saveSliderEvent(SLIDER_NEW_AGGREGATE_LEFT),
  });

  const newAggregateSliderRightChange = (event, ui) => {
    const leftWidth = sliderValue("#newaggregatesliderleft");
    const rightWidth = ui.value;
    const recipeCount = aggregate_vitamins.length;

    jQuery(".agg-package-col").css("width", ui.value);
    jQuery(
      "#newaggregatenutritionfactstable, .agg-ingredient-list, .agg-ingredient-list-recipe-name, .agg-allergen-list, " +
        "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, #facility-allergen-list, " +
        "#bioengineered-claim, .watermark"
    ).css("width", leftWidth + (rightWidth + 7) * recipeCount);

    jQuery("#slider-size2").html(rightWidth);
    adjustDualServingSizeLineHeight();
    setNewAggregateHeadingSize();
  };

  jQuery("#newaggregatesliderright").slider({
    min: 85,
    max: 140,
    value: 100,
    slide: newAggregateSliderRightChange,
    change: newAggregateSliderRightChange,
    stop: saveSliderEvent(SLIDER_NEW_AGGREGATE_RIGHT),
  });

  const infantSliderChange = (event, ui) => {
    jQuery("#infantnutritionfactstable, .infantvitaminbullet, .infantvitaminright").css(
      "width",
      ui.value
    );

    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 10);

    jQuery("#infantheading").css("font-size", ui.value / 8.43);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#infantslider").slider({
    min: 160,
    max: 250,
    value: 207,
    slide: infantSliderChange,
    change: infantSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const newInfantSliderChange = (event, ui) => {
    jQuery("#newinfantnutritionfactstable").css("width", ui.value);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 10);
    jQuery("#newinfantheading").css("font-size", ui.value / 8.43);
    adjustServingFontSize();
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newinfantslider").slider({
    min: 160,
    max: 250,
    value: 207,
    slide: newInfantSliderChange,
    change: newInfantSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const childSliderChange = (event, ui) => {
    jQuery("#childnutritionfactstable, .childvitaminbullet, .childvitaminright").css(
      "width",
      ui.value
    );
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 10);
    jQuery("#childheading").css("font-size", ui.value / 8.43);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#childslider").slider({
    min: 180,
    max: 250,
    value: 207,
    slide: childSliderChange,
    change: childSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const newChildSliderChange = (event, ui) => {
    jQuery("#newchildnutritionfactstable").css("width", ui.value);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 10);
    jQuery("#newchildheading").css("font-size", ui.value / 8.43);
    adjustServingFontSize();
    jQuery(".asterisk_text:visible").css("width", ui.value - 5);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newchildslider").slider({
    min: 180,
    max: 250,
    value: 207,
    slide: newChildSliderChange,
    change: newChildSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const linearSliderChange = (event, ui) => {
    jQuery("#linearnutritionfactstable").css("width", ui.value);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 8);

    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#linearslider").slider({
    min: 140,
    max: 1200,
    value: 430,
    slide: linearSliderChange,
    change: linearSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const newLinearSliderChange = (event, ui) => {
    jQuery("#newlinearnutritionfactstable").css("width", ui.value);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 8);
    jQuery("#slider-size").html(ui.value);
    adjustNewLinearLineHeightForCalorieFont();
  };

  jQuery("#newlinearslider").slider({
    min: 140,
    max: 1200,
    value: 430,
    slide: newLinearSliderChange,
    change: newLinearSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const aggregateSliderChange = (event, ui) => {
    jQuery(".dual-left-col").css("width", ui.value);
    jQuery(
      "#calorieconversionaggregate, .carbconversionaggregate, .protein-conversion, " +
        ".asterisksectionaggregate, #aggregateasterisktable, #asterisksection-replace-aggregate"
    ).css("width", ui.value + 90);
    jQuery(".dual-multi-line-inner-div").css("width", ui.value + 45);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", ui.value + 8 + 90);
    jQuery("#aggregatenutritionheading").css("font-size", (ui.value + 90) / 8.43);
    jQuery(".asterisk_text:visible").css("width", ui.value - 5 + 90);
    jQuery("#insignificant-nutrients-list-as-packaged").css("width", ui.value + 90);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#aggregateslider").slider({
    min: 100,
    max: 180,
    value: 140,
    slide: aggregateSliderChange,
    change: aggregateSliderChange,
    stop: saveSliderEvent(SLIDER_SOLE),
  });

  const tabularSliderChange = (event, ui) => {
    if (jQuery("#simplifiedformattoggle").is(":checked")) {
      jQuery("#tabular_nutrient_cols").css("width", ui.value);
      jQuery(
        "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
          "#facility-allergen-list, #bioengineered-claim, .watermark"
      ).css("width", jQuery("#tabularnutritionfactstable").outerWidth());
    } else {
      jQuery("#tabular_nutrient_cols").css("width", ui.value * 2 + 7);
      jQuery(
        "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
          "#facility-allergen-list, #bioengineered-claim, .watermark"
      ).css("width", jQuery("#tabularnutritionfactstable").outerWidth());
    }

    jQuery(".tabular_nutrient_col").css("width", ui.value);
    jQuery(".vitaminbullettabular").css(
      "margin-left",
      Math.max(0, (17 / 55) * (ui.value - 175) + 7)
    );
    jQuery(".vitaminbullettabular").css(
      "margin-right",
      Math.max(0, (17 / 55) * (ui.value - 175) + 7)
    );
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#tabularslider").slider({
    min: 160,
    max: 199,
    value: 175,
    slide: tabularSliderChange,
    change: tabularSliderChange,

    stop: (event, ui) => {
      rebuildFunction();
      saveSliderEvent(SLIDER_SOLE)(event, ui);
    },
  });

  const newTabularSliderChange = (event, ui) => {
    if (jQuery("#newsimplifiedformattoggle").is(":checked")) {
      jQuery("#new_tabular_nutrient_cols").css("width", ui.value);
    } else {
      jQuery("#new_tabular_nutrient_cols").css("width", ui.value * 2 + 7);
    }

    jQuery(".new_tabular_nutrient_col").css("width", ui.value);
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css(
      "width",
      document.querySelector("#newtabularnutritionfactstable").getBoundingClientRect().width
    );

    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newtabularslider").slider({
    min: 150,
    max: 240,
    value: 210,
    slide: newTabularSliderChange,
    change: newTabularSliderChange,

    stop: (event, ui) => {
      rebuildFunction();
      saveSliderEvent(SLIDER_NEW_TABULAR_SINGLE)(event, ui);
    },
  });

  const newDualTabularSliderLeftChange = (event, ui) => {
    const rightWidth = sliderValue("#newdualtabularsliderright");
    jQuery(".tabular-dual-left-col").css("width", ui.value);

    if (jQuery("#newsimplifiedformattoggle").is(":checked")) {
      jQuery("#new_tabular_dual_asterisk_row, #insignificant-nutrients-list-new-tabular").css(
        "width",
        rightWidth * 2 + ui.value + 9
      );
      jQuery(".asterisk_text").css("width", ui.value + rightWidth * 2 + 9 - 5);
    } else {
      jQuery("#new_tabular_dual_asterisk_row, #insignificant-nutrients-list-new-tabular").css(
        "width",
        rightWidth * 4 + ui.value * 2 + 29
      );
      jQuery(".asterisk_text").css("width", ui.value * 2 + rightWidth * 4 + 29 - 5);
    }

    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", jQuery("#newtabularnutritionfactstable").outerWidth());
    jQuery(".subhairlineseparator:visible").css("width", ui.value - 20);
    jQuery(".subsubhairlineseparator:visible").css("width", ui.value - 40);
    jQuery("#slider-size").html(ui.value);
  };

  jQuery("#newdualtabularsliderleft").slider({
    min: 100,
    max: 130,
    value: 115,
    slide: newDualTabularSliderLeftChange,
    change: newDualTabularSliderLeftChange,
    stop: saveSliderEvent(SLIDER_NEW_TABULAR_DUAL_LEFT),
  });

  const newDualTabularSliderRightChange = (event, ui) => {
    const leftWidth = sliderValue("#newdualtabularsliderleft");
    jQuery(".tabular-dual-serving-col, .tabular-dual-package-col").css("width", ui.value);

    if (jQuery("#newsimplifiedformattoggle").is(":checked")) {
      jQuery("#new_tabular_dual_asterisk_row, #insignificant-nutrients-list-new-tabular").css(
        "width",
        ui.value * 2 + leftWidth + 9
      );
      jQuery(".asterisk_text:visible").css("width", leftWidth + ui.value * 2 + 9 - 5);
    } else {
      jQuery("#new_tabular_dual_asterisk_row, #insignificant-nutrients-list-new-tabular").css(
        "width",
        ui.value * 4 + leftWidth * 2 + 29
      );
      jQuery(".asterisk_text:visible").css("width", leftWidth * 2 + ui.value * 4 + 29 - 5);
    }
    jQuery(
      "#recipe-show-ingredient-list, #allergen-list, .allergen-list-canada-english, " +
        ".allergen-list-canada-french, .facility-allergen-list-canada-english, " +
        ".facility-allergen-list-canada-french, #recipe_manufactured_at, " +
        "#facility-allergen-list, #bioengineered-claim, .watermark"
    ).css("width", jQuery("#newtabularnutritionfactstable").outerWidth());
    jQuery("#slider-size2").html(ui.value);
  };

  jQuery("#newdualtabularsliderright").slider({
    min: 60,
    max: 95,
    value: 77,
    slide: newDualTabularSliderRightChange,
    change: newDualTabularSliderRightChange,
    stop: saveSliderEvent(SLIDER_NEW_TABULAR_DUAL_RIGHT),
  });
};

export const loadSliders = ({ sliders }) => {
  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("legacy_fda/adult/vertical")) {
    setSliderValue("#standardslider", sliders[SLIDER_SOLE]);
  }

  if (
    isNumber(sliders[SLIDER_NEW_VERTICAL_SINGLE]) &&
    isFormat("fda/adult/vertical") &&
    jQuery("#newnutritionfactstable:visible").length > 0
  ) {
    setSliderValue("#newverticalslider", sliders[SLIDER_NEW_VERTICAL_SINGLE]);
  }

  if (
    sliders[SLIDER_NEW_VERTICAL_SINGLE] == null &&
    isFormat("fda/adult/vertical") &&
    jQuery("#newnutritionfactstable:visible").length > 0
  ) {
    refreshSlider("#newverticalslider");
  }

  if (
    isNumber(sliders[SLIDER_SOLE]) &&
    isFormat("canada/adult/vertical") &&
    jQuery("#newcanadanutritionfactstable:visible").length > 0
  ) {
    setSliderValue("#newcanadaslider", sliders[SLIDER_SOLE]);
  }

  if (
    isNumber(sliders[SLIDER_SOLE]) &&
    isFormat("canada/adult/linear") &&
    jQuery("#newlinearcanadanutritionfactstable:visible").length > 0
  ) {
    setSliderValue("#newlinearcanadaslider", sliders[SLIDER_SOLE]);
  }

  if (
    isNumber(sliders[SLIDER_SOLE]) &&
    isFormat("canada/adult/tabular") &&
    jQuery(".CaTabularNFP:visible").length > 0
  ) {
    setSliderValue("#newtabularcanadaslider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("canada/adult/vertical/as_prepared")) {
    setSliderValue("#canada-as-prepared-slider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_CA_AGGREGATE_LEFT]) && isFormat("canada/adult/vertical/aggregate")) {
    setSliderValue("#ca-aggregate-slider-left", sliders[SLIDER_CA_AGGREGATE_LEFT]);
  }

  if (isNumber(sliders[SLIDER_CA_AGGREGATE_RIGHT]) && isFormat("canada/adult/vertical/aggregate")) {
    setSliderValue("#ca-aggregate-slider-right", sliders[SLIDER_CA_AGGREGATE_RIGHT]);
  }

  if (
    isNumber(sliders[SLIDER_NEW_VERTICAL_DUAL_LEFT]) &&
    isFormat("fda/adult/vertical") &&
    jQuery("#newdualnutritionfactstable:visible").length > 0
  ) {
    setSliderValue("#newdualsliderleft", sliders[SLIDER_NEW_VERTICAL_DUAL_LEFT]);
  }

  if (
    sliders[SLIDER_NEW_VERTICAL_DUAL_LEFT] == null &&
    isFormat("fda/adult/vertical") &&
    jQuery("#newdualnutritionfactstable:visible").length > 0
  ) {
    refreshSlider("#newdualsliderleft");
  }

  if (
    isNumber(sliders[SLIDER_NEW_VERTICAL_DUAL_RIGHT]) &&
    isFormat("fda/adult/vertical") &&
    jQuery("#newdualnutritionfactstable:visible").length > 0
  ) {
    jQuery("#newdualsliderright").slider(
      "option",
      "value",
      sliders[SLIDER_NEW_VERTICAL_DUAL_RIGHT]
    );
  }

  if (
    isNumber(sliders[SLIDER_NEW_TABULAR_DUAL_LEFT]) &&
    isFormat("fda/adult/tabular") &&
    jQuery("#new_tabular_dual_nutrient_cols").length > 0
  ) {
    jQuery("#newdualtabularsliderleft").slider(
      "option",
      "value",
      sliders[SLIDER_NEW_TABULAR_DUAL_LEFT]
    );
  }

  if (
    isNumber(sliders[SLIDER_NEW_TABULAR_DUAL_RIGHT]) &&
    isFormat("fda/adult/tabular") &&
    jQuery("#new_tabular_dual_nutrient_cols").length > 0
  ) {
    jQuery("#newdualtabularsliderright").slider(
      "option",
      "value",
      sliders[SLIDER_NEW_TABULAR_DUAL_RIGHT]
    );
  }

  if (
    isNumber(sliders[SLIDER_NEW_AS_PREPARED_LEFT]) &&
    isFormat("fda/adult/vertical/as_prepared")
  ) {
    setSliderValue("#newaspreparedsliderleft", sliders[SLIDER_NEW_AS_PREPARED_LEFT]);
  }

  if (
    isNumber(sliders[SLIDER_NEW_AS_PREPARED_RIGHT]) &&
    isFormat("fda/adult/vertical/as_prepared")
  ) {
    setSliderValue("#newaspreparedsliderright", sliders[SLIDER_NEW_AS_PREPARED_RIGHT]);
  }

  if (isNumber(sliders[SLIDER_NEW_AGGREGATE_LEFT]) && isFormat("fda/adult/vertical/aggregate")) {
    setSliderValue("#newaggregatesliderleft", sliders[SLIDER_NEW_AGGREGATE_LEFT]);
  }

  if (isNumber(sliders[SLIDER_NEW_AGGREGATE_RIGHT]) && isFormat("fda/adult/vertical/aggregate")) {
    setSliderValue("#newaggregatesliderright", sliders[SLIDER_NEW_AGGREGATE_RIGHT]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("legacy_fda/adult/linear")) {
    setSliderValue("#linearslider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("fda/adult/linear")) {
    setSliderValue("#newlinearslider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("legacy_fda/adult/tabular")) {
    setSliderValue("#tabularslider", sliders[SLIDER_SOLE]);
  }

  if (
    isNumber(sliders[SLIDER_NEW_TABULAR_SINGLE]) &&
    isFormat("fda/adult/tabular") &&
    jQuery("#new_tabular_dual_nutrient_cols").length == 0
  ) {
    setSliderValue("#newtabularslider", sliders[SLIDER_NEW_TABULAR_SINGLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("legacy_fda/adult/vertical/as_prepared")) {
    setSliderValue("#aggregateslider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("legacy_fda/infant/vertical")) {
    setSliderValue("#infantslider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("fda/infant/vertical")) {
    setSliderValue("#newinfantslider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("legacy_fda/child/vertical")) {
    setSliderValue("#childslider", sliders[SLIDER_SOLE]);
  }

  if (isNumber(sliders[SLIDER_SOLE]) && isFormat("fda/child/vertical")) {
    setSliderValue("#newchildslider", sliders[SLIDER_SOLE]);
  }
};

export const triggerSliders = () => {
  onFormat({
    "legacy_fda/adult/vertical"() {
      refreshSlider("#standardslider");
    },

    "fda/adult/vertical"() {
      if (jQuery("#newnutritionfactstable").length > 0) {
        refreshSlider("#newverticalslider");
      } else {
        refreshSlider("#newdualsliderleft");
        refreshSlider("#newdualsliderright");
      }
    },

    "legacy_fda/adult/tabular"() {
      refreshSlider("#tabularslider");
    },

    "fda/adult/tabular"() {
      if (jQuery("#new_tabular_dual_nutrient_cols").length > 0) {
        refreshSlider("#newdualtabularsliderleft");
        refreshSlider("#newdualtabularsliderright");
      } else {
        refreshSlider("#newtabularslider");
      }
    },

    "fda/adult/vertical/as_prepared"() {
      refreshSlider("#newaspreparedsliderleft");
      refreshSlider("#newaspreparedsliderright");
    },

    "fda/adult/vertical/aggregate"() {
      refreshSlider("#newaggregatesliderleft");
      refreshSlider("#newaggregatesliderright");
    },

    "legacy_fda/adult/vertical/as_prepared"() {
      refreshSlider("#aggregateslider");
    },

    "legacy_fda/adult/linear"() {
      refreshSlider("#linearslider");
    },

    "fda/adult/linear"() {
      refreshSlider("#newlinearslider");
    },

    "legacy_fda/infant/vertical"() {
      refreshSlider("#infantslider");
    },

    "legacy_fda/child/vertical"() {
      refreshSlider("#childslider");
    },

    "fda/infant/vertical"() {
      refreshSlider("#newinfantslider");
    },

    "fda/child/vertical"() {
      refreshSlider("#newchildslider");
    },

    "canada/adult/vertical"() {
      refreshSlider("#newcanadaslider");
    },

    "canada/adult/linear"() {
      refreshSlider("#newlinearcanadaslider");
    },

    "canada/adult/tabular"() {
      refreshSlider("#newtabularcanadaslider");
    },

    "canada/adult/vertical/as_prepared"() {
      refreshSlider("#canada-as-prepared-slider");
    },

    "canada/adult/vertical/aggregate"() {
      refreshSlider("#ca-aggregate-slider-left");
      refreshSlider("#ca-aggregate-slider-right");
    },
  });
};
